/*
 * Bind "toggle" elements (currently just used for menus)
 */

function isClickInsideEl(event, targetElement) {
  if (event.target === targetElement) return true;
  return targetElement.contains(event.target);
}

function openToggleEls(toggle) {
  const els = getToggleEls(toggle);
  els.forEach((el) => {
    el.setAttribute("data-state", "visible");
  });
  toggle.setAttribute("data-state", "visible");
}

function closeToggleEls(toggle) {
  const els = getToggleEls(toggle);
  els.forEach((el) => {
    el.setAttribute("data-state", "hiding");
    setTimeout(() => {
      el.setAttribute("data-state", "hidden");
    }, 200);
  });
  toggle.setAttribute("data-state", "hiding");
  setTimeout(() => {
    toggle.setAttribute("data-state", "hidden");
  }, 200);
}

function getToggleEls(toggle) {
  const els = [];
  // Get all selectors per toggle
  const selectors = toggle.getAttribute("data-els").split(",");
  // Bind toggle for each selector
  selectors.forEach((selector) => {
    selector = selector.trim();
    const el = document.querySelector(selector);
    if (el) {
      els.push(el);
    }
  });
  return els;
}

function enableToggle(toggle) {
  // Bind toggle button
  toggle.setAttribute("data-state", "hidden");
  toggle.addEventListener("click", () => {
    if (toggle.getAttribute("data-state") === "hidden") {
      openToggleEls(toggle);
    } else {
      closeToggleEls(toggle);
    }
  });
  // Set initial state for els
  const els = getToggleEls(toggle);
  els.forEach((el) => {
    el.setAttribute("data-toggle-el", "");
    el.setAttribute("data-state", "hidden");
  });
  // Figure out if we should close the toggle when there's a click outside of the el
  const closeOnOutsideClick = toggle.hasAttribute("data-close-outside")
    ? true
    : false;
  if (closeOnOutsideClick === true) {
    window.addEventListener("click", (e) => {
      let foundDescendant = false;
      if (isClickInsideEl(e, toggle)) {
        foundDescendant = true;
      }
      els.forEach((el) => {
        if (isClickInsideEl(e, el)) {
          foundDescendant = true;
        }
      });
      if (foundDescendant === false) {
        if (toggle.getAttribute("data-state") === "visible") {
          closeToggleEls(toggle);
        }
      }
    });
  }
  // Figure out if we should close the toggle when a link is clicked inside the el
  const closeOnLinkClick = toggle.hasAttribute("data-close-on-link")
    ? true
    : false;
  if (closeOnLinkClick === true) {
    els.forEach((el) => {
      const links = el.querySelectorAll("a");
      links.forEach((link) => {
        link.addEventListener("click", () => {
          closeToggleEls(toggle);
        });
      });
    });
  }
  // Figure out if we need to focus an element when a toggle is opened
  const focusOnOpen = toggle.getAttribute("data-focus");
  if (focusOnOpen) {
    const targetEl = document.querySelector(focusOnOpen);
    if (targetEl) {
      toggle.addEventListener("click", () => {
        targetEl.focus();
      });
    }
  }
}

export default function enableToggles() {
  // Get all toggles on page
  const toggles = document.querySelectorAll("[data-toggle]");
  toggles.forEach((toggle) => {
    enableToggle(toggle);
  });
}
